import api from ".././api";

export const getCities = async({stateSelected}) => {
    return await api.get(`/city?stateName=${stateSelected}`)
  };

export const getStates = async() => {
    return await api.get(`/uf/states`)
};